import {PageProps} from '@/types';
import Page from "@/Pages/Page";
import {CommercialPageType, CommercialType} from "@/Atoms/Commercial";
import AdvertisementSection from "@/Organisms/Advertisements/AdvertisementSection";
import React, {useEffect, useRef} from "react";
import './ArticleDetail.scss'
import SharePage from "@/Molecules/Socials/SharePage";
import {MetaTag} from "@/types/MetaTab";

export default function ExperienceDetail(
  {
    item,
    ziggy,
  }: PageProps<{
    item: any,
    ziggy: {
      location: string
    }
  }>) {

  const adEveryNth = 5;

  const contentRef = useRef(null);

  // Render a advertisement block every 5 paragraphs
  useEffect(() => {

    if (contentRef.current){
      const div = contentRef.current as HTMLDivElement
      const paragraphs = div.querySelectorAll('p')
      let index = 0;
      const contentLength = 0
      paragraphs.forEach((paragraph: HTMLParagraphElement) => {
        if (paragraph.textContent && paragraph.textContent.length < 200){
          return;
        }
        if (index > 0 && index % adEveryNth === 0){


          const adElement = document.createElement('div');
          adElement.dataset.adType = CommercialType.Leaderboard;
          paragraph.parentElement?.insertBefore( adElement, paragraph)
        }
        index++;
      });
      return () => {
        // Remove advertisements when element re-renders/destructs
        div.querySelectorAll('[data-ad-type]').forEach(el => el.remove())
      }
    }
  }, []);



  const metaTags: MetaTag[] = [
    // OpenGraph
    {
      property: 'og:title',
      content: item.title + ' - Mensenlinq',
    },{
      property: 'og:type',
      content: 'website',
    },{
      property: 'og:description',
      content: item.title + ' - Mensenlinq',
    },{
      property: 'og:image',
      content: item.image,
    },{
      property: 'og:url',
      content: ziggy.location,
    },

    // Twitter
    {
      property: 'twitter:card',
      content: 'summary_large_image',
    },{
      property: 'twitter:title',
      content: item.title + ' - Mensenlinq',
    },{
      property: 'twitter:description',
      content: item.title + ' - Mensenlinq',
    },{
      property: 'twitter:url',
      content: ziggy.location,
    },{
      property: 'twitter:image',
      content: item.image,
    }]

    return (
      <Page title={item.title} pageType={CommercialPageType.Detail} adUnit={'article'} metaTags={metaTags}>

        <AdvertisementSection className={'bg-beige'} />

        <section className="art">
          <div className={'container'}>

            <div className={'art__header'}>
              <h1 className="art__title">{item.title}</h1>
            </div>
            <div className={'art__content'} ref={contentRef} dangerouslySetInnerHTML={{__html: item.content}}></div>
            <hr />
            <div className={'flex justify-center'}>
              <SharePage
                label={'Vond je dit een nuttig artikel? Deel het: '}
                url={ziggy.location}
              />
            </div>
          </div>
        </section>

        <AdvertisementSection className={'bg-beige'}/>



        {/*  TODO: add related items*/}


      </Page>
    );
}
